import PageTitle from './PageTitle'
import PageSubtitle from './PageSubtitle'
import ButtonEmailHover from './ButtonEmailHover'

export default function LandingPageCopy (props) {


  let liStyle = {
    margin: '0 0 14px 0',
  }

  return(
    <div>
      <div style={{display: 'flex', background: "#80a3db",}}>
        <div style={{
            width: '7vw',
          }}>
        </div>
        <div style={{width: '86vw', margin: '0 0 80px 0'}}>
          <PageTitle
            pageTitle = 'Research Synthase'
            />
          <PageSubtitle
            pageSubtitle = 'Helping premedical students find better research projects'
            />
          <div style={{display: 'flex', justifyContent: 'center'}}>
            <div style = {{width: '400px'}}>
              <ButtonEmailHover
                email = "researchsynthase@gmail.com"
                subject = "Medical school research project"
                emailBody = "Thanks for your interest!  Please send your name,your university, and what medical specialty you are interested in..."
                buttonName = "Get started today"
              />
            </div>
          </div>
          
        </div>
        <div style={{
            width: '7vw',
          }}>
        </div>
      </div>
      <div style={{
          background: '#FFF',
        }}>
        
        <div style={{
            display: 'flex',
            justifyContent: 'center',
          }}>
          <div style={{
              maxWidth: '800px',
              fontSize: '20px',
              margin: '0 0 100px 0'
            }}>
              <p>Reasons you should consider using Research Synthase:</p>
              <ul>
                <li style={liStyle}>
                  Work with a medical doctor
                </li>
                <li style={liStyle}>
                  Get published fast (usually about 1 year)
                </li>
                <li style={liStyle}>
                  Choose the medical specialty that interests you
                </li>
                <li style={liStyle}>
                  Leverage your research time into letters of recommendation and clinical experience
                </li>
              </ul>
            
            <h1 
              style={{
                textAlign: 'center',
                fontSize: '40px',
                fontWeight: '400',
                padding: '20px 0 0 0', 
                margin: '0',
              }}>Time goes faster than you think
            </h1>
            <h1 
              style={{
                textAlign: 'center',
                fontSize: '40px',
                fontWeight: '400',
                padding: '20px 0 0 0',
                margin: '0',
              }}>Get started today!
            </h1>
          </div>
        </div>
      </div>
    </div>

  )
}
